import { I18nLang } from '@pharmsnap/shared/i18n'
import { computed, getCurrentInstance } from '@vue/composition-api'
import VueI18n from 'vue-i18n'
import { ILang } from '../types/base'

export function useLocale() {
  const ins = getCurrentInstance()
  const locale = computed(() => {
    return ins?.proxy.$i18n.locale as I18nLang
  })
  const isCN = computed(() => {
    return locale.value === 'cn'
  })
  const isJP = computed(() => {
    return locale.value === 'jp'
  })
  /**
   * 是否使用全角标点(【】、：等)。中文和日文排版都用全角,英文用半角
   */
  const isFullWidthPunctuation = computed(() => {
    return isCN.value || isJP.value
  })
  const $i18n = computed(() => {
    return ins?.proxy.$i18n as VueI18n
  })
  /**
   * 界面语言的大写形式,仅用于前端展示层(日期格式化等)
   * 注意: 不要用于 API 请求参数,请求数据语言请使用 dataLang
   */
  const localeUpcase = computed(() => {
    return locale.value.toUpperCase() as ILang
  })
  /**
   * 请求后端数据的语言。后端暂未支持日文数据,日文界面下降级为英文
   */
  const dataLang = computed<ILang>(() => {
    return isCN.value ? 'CN' : 'EN'
  })
  /**
   * 后端数据字段的语言后缀,用于拼接 display_name_cn / name_en 这类字段名。
   * 后端暂未提供 _jp 字段,日文界面下降级取英文
   */
  const fieldLang = computed<'cn' | 'en'>(() => {
    return isCN.value ? 'cn' : 'en'
  })
  function tsLangMap(map?: Record<I18nLang, string>) {
    if (!map) {
      console.warn(`语言包配置表获取失败,请检查`)
      return ''
    }
    return map[locale.value]
  }
  function ts(key: string, values?: VueI18n.Values) {
    return ins?.proxy.$t(key, values) as string
  }

  function tsc(key: string, count: number) {
    return ins?.proxy.$tc(key, count) as string
  }
  /**
   * 按当前界面语言取文案。三种语言必须齐全,漏译在编译期即可发现
   * @param texts 包含 cn/en/jp 的文案对象;后端数据无日文时 jp 传英文
   */
  function tsText(texts: { cn: string; en: string; jp: string }): string {
    if (isCN.value) {
      return texts.cn
    }
    if (isJP.value) {
      return texts.jp
    }
    return texts.en
  }

  return { locale, localeUpcase, dataLang, fieldLang, isCN, isJP, isFullWidthPunctuation, $i18n, tsLangMap, ts, tsc, $t: ts, tsText }
}
